import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { getUserData, useLogin } from "../auth/hooks/useLogin";
import CoreContextProvider from "../common/components/common/CoreProvider";
import { errorMsg, successMsg } from "../helper/message";
import {
  getListCountry,
  getListLanguage,
  updateCurentUserPassword,
  updateUserInfo
} from "./service/userService";

const UserProvider = (props) => {
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState();
  const [listLanguage, setListLanguage] = useState();
  const [listCountry, setListCountry] = useState();
  const { getAccountInfo } = useLogin();

  const getUserDataInfo = async () => {
    try {
      setLoading(true);
      const userDetail = await getUserData();
      setUserData(userDetail?.data?.data);
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const formContextUser = useForm({
    mode: "onSubmit",
    defaultValues: {},
  });

  const formContextPassword = useForm({
    mode: "onSubmit",
    defaultValues: {},
  });

  const handleSubmitUserInfo = formContextUser.handleSubmit(async (val) => {
    try {
      await updateUserInfo(val);
      getAccountInfo();
      successMsg("Thành công");
    } catch (err) {
      errorMsg(err, "Có lỗi");
    }
  });

  const getLanguage = async () => {
    try {
      const res = await getListLanguage({ page: 0, size: 10000 });
      setListLanguage(res?.data?.data?.content);
    } catch (err) {}
  };

  const getCountry = async () => {
    try {
      const res = await getListCountry({ page: 0, size: 10000 });
      setListCountry(res?.data?.data?.content);
    } catch (err) {}
  };

  const handleSubmitChangePassword = formContextPassword.handleSubmit(
    async (val) => {
      try {
        const dataBody = {
          oldPassword: val.oldPassword,
          newPassword: val.newPassword,
          id: userData?.id,
        };
        await updateCurentUserPassword(dataBody);
        successMsg("Thành công");
      } catch (err) {
        errorMsg(err, "Có lỗi");
      }
    }
  );

  useEffect(() => {
    getUserDataInfo();
    getLanguage();
    getCountry();
  }, []);

  useEffect(() => {
    userData && formContextUser.reset(userData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  const data = {
    loading,
    formContextUser,
    handleSubmitUserInfo,
    formContextPassword,
    handleSubmitChangePassword,
    listLanguage,
    listCountry,
  };
  return <CoreContextProvider {...data}>{props.children}</CoreContextProvider>;
};

export default UserProvider;
